import { memo } from "react";
import { generatePath } from "react-router";

import { cn } from "@/lib/chillnn/cn";
import type { HotelTopQuery } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { StepHeader } from "../_step-header";
import { TodoListSectionItem } from "../_todo-list-section-item";
import { TodoListSectionWrapper } from "../_todo-list-section-wrapper";
import { TodoListWrapper } from "../_todo-list-wrapper";

type Props = {
	startGuide: HotelTopQuery["startGuide"];
	disabled: boolean;
};

const HOTEL_POLICY_NOT_REGISTERED_MESSAGE = "ホテルポリシーの設定をしてください";

export const Step5 = memo(
	({
		startGuide: {
			hotelID,
			isHotelPolicyRegistered,
			isCreditInfoRegistered,
			isDepositAccountRegistered,
			isBillingInfoRegistered,
		},
		disabled,
	}: Props) => {
		return (
			<div className={cn("space-y-4", disabled && "pointer-events-none opacity-30")}>
				<StepHeader title="Step5" description="決済情報・料金プランの登録" />
				<p className="text-sm">
					<strong>※</strong>{" "}
					<strong className="text-brand">
						入金先情報は事前決済予約の入金先になります。登録がない場合事前決済が利用できませんので、必ず入力してください
					</strong>
				</p>

				<TodoListWrapper>
					<TodoListSectionWrapper>
						<TodoListSectionItem
							title={"お支払い情報"}
							transitionCondition={isHotelPolicyRegistered}
							alertMessageWhenNotTransition={HOTEL_POLICY_NOT_REGISTERED_MESSAGE}
							pagePath={generatePath(PATHS.SETTINGS.PAYMENT_CREDIT, { hotelID })}
							checkBoxStatus={isCreditInfoRegistered}
							showCheckBox={true}
						/>
						<TodoListSectionItem
							title={"入金先情報"}
							transitionCondition={isHotelPolicyRegistered}
							alertMessageWhenNotTransition={HOTEL_POLICY_NOT_REGISTERED_MESSAGE}
							pagePath={generatePath(PATHS.SETTINGS.PAYMENT_DEPOSIT_ACCOUNT, { hotelID })}
							checkBoxStatus={isDepositAccountRegistered}
							showCheckBox={true}
						/>
						<TodoListSectionItem
							title={"料金プラン"}
							transitionCondition={isHotelPolicyRegistered}
							alertMessageWhenNotTransition={HOTEL_POLICY_NOT_REGISTERED_MESSAGE}
							pagePath={generatePath(PATHS.SETTINGS.BILLING, { hotelID })}
							checkBoxStatus={isBillingInfoRegistered}
							showCheckBox={true}
						/>
					</TodoListSectionWrapper>
				</TodoListWrapper>
			</div>
		);
	},
);

Step5.displayName = "Step5";
